export default "__VITE_ASSET__DhBxveOx__"